import config from './config';
import CryptoJS from './libs/crypto/crypto.js';
import ajax from '../helpers/ajax';
import { getCookie, setCookie, isValidPage } from '../helpers/utils';

/**
 * Random string
 *
 * @param {number} len
 * @return {string}
 */
function randomString(len) {
  var str = "";

  for (var i = 0; i < len; i++) {
    var rand = Math.floor(Math.random() * 62);
    var charCode = rand += rand > 9 ? (rand < 36 ? 55 : 61) : 48;

    str += String.fromCharCode(charCode);
  }

  return str;
}

/**
 * Encrypt data by HMAC SHA256
 *
 * @param {Object} data
 * @return {string}
 */
function encode(data) {
  return CryptoJS.HmacSHA256(
    JSON.stringify(data),
    config.report_key
  ).toString();
}

/**
 * Get cart token in cookies, if not, fake cart token
 *
 * @return {string}
 */
function getCartToken() {
  let cart = getCookie('cart');

  if (cart) {
    return cart;
  }

  cart = getCookie('ar_cart');

  if (cart) {
    return cart;
  }

  cart = randomString(32);

  // expires 14 days
  setCookie('ar_cart', cart, 14);

  return cart;
}

/**
 * Listen on add to cart
 *
 * @param {number} shopId
 * @param {string} url
 * @return {void}
 */
function onAddToCart(shopId, url) {
  let arCart = getCookie('ar_cart');

  if (
    !url
    || !(typeof url === 'string' || url instanceof String)
    || url.indexOf('cart/add.js') < 0
    || !arCart
  ) {
    return;
  }

  replateCartToken(shopId, arCart, getCookie('cart'));
}

function checkCartToken(shopId) {
  let arCart = getCookie('ar_cart');
  let cart = getCookie('cart');

  if (!arCart || !cart) {
    return;
  }

  replateCartToken(shopId, arCart, cart);
}

function replateCartToken(shopId, oldCart, newCart) {
  let data = {
    shop_id: shopId,
    old_cart: oldCart,
    new_cart: newCart
  };

  ajax.post(config.report_url + '/widget/replace-cart', data, {
    'X-AR-Report-Signature': encode(data)
  }).then(response => {
    setCookie('ar_cart', '', 0);
  });
}

/**
 * Track views of widget
 *
 * @param {number} shopId - The ID of store
 * @param {Array.<number>} widgetIds - List of widget's ID
 * @return {void}
 */
function trackViews(shopId, widgetIds) {
  const page = typeof alireviews_page_type != 'undefined' ? alireviews_page_type : null;
  if (!isValidPage(page)) {
    return;
  }

  let data = {
    shop_id: shopId,
    theme_id: window.Shopify.theme.id,
    page: page,
    widget_ids: widgetIds,
  };

  return ajax.post(config.report_url + '/widget/trackes/views', data, {
    'X-AR-Report-Signature': encode(data)
  });
}

/**
 * Track click review of widget
 *
 * @param {number} shopId
 * @param {number} widgetId
 * @param {number} productId
 * @return {void}
 */
function trackClicks(shopId, widgetId, productId) {
  const page = typeof alireviews_page_type != 'undefined' ? alireviews_page_type : null;
  if (!isValidPage(page)) {
    return;
  }

  let cartToken = getCartToken();

  let data = {
    shop_id: shopId,
    theme_id: window.Shopify.theme.id,
    page: page,
    widget_id: widgetId,
    product_id: productId,
    cart_token: cartToken,
  };

  return ajax.post(config.report_url + '/widget/trackes/clicks', data, {
    'X-AR-Report-Signature': encode(data)
  });
}

export {
  trackViews,
  trackClicks,
  onAddToCart,
  checkCartToken,
}
